import { env } from './env';
export const getAuthToken = () => {
    try {
        const raw = localStorage.getItem(env.sessionStorageKey);
        if (!raw)
            return null;
        const parsed = JSON.parse(raw);
        if (typeof parsed !== 'object' || parsed === null)
            return null;
        const token = parsed.token;
        if (typeof token !== 'string' || !token.trim())
            return null;
        return token;
    }
    catch {
        return null;
    }
};
/**
 * Fire a window-level event when any API returns 401.
 * AuthContext listens for this and signs the user out + redirects to /sign-in.
 */
export const handleUnauthorized = () => {
    if (typeof window === 'undefined')
        return;
    window.dispatchEvent(new CustomEvent('auth:unauthorized'));
};
